import { motion } from 'framer-motion';
import React, { useRef, useState, useEffect } from 'react';

const FlipCard = ({ children, sx }) => {
  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      { threshold: 0.4 } // Trigger when 40% of the element is visible
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <motion.div
        ref={ref} // Keep the ref for intersection visibility
        initial={{ rotateY: 0 }}
        animate={{ rotateY: isVisible ? 360 : 0 }} // Flip when visible
        // whileHover={{ rotateY: 180 }} // Flip on hover
        transition={{ duration: 2, repeat:Infinity,  }}
        style={{
          transformStyle: 'preserve-3d',
          cursor: 'pointer',
          alignContent:'center',
          height: '100%', // Ensure height is preserved
          ...sx, // Spread the sx for custom styling
        }}
      >
        {children}
      </motion.div>
    </>
  );
};

export default FlipCard;
